const type = 'SET_ADVANCE_INVOICE_INSTALLMENT_ERROR';

const setAdvanceInvoiceInstallmentError = (data = {}) => ({
  data,
  type,
});

export { type };
export default setAdvanceInvoiceInstallmentError;
